import { render, staticRenderFns } from "./AppFooterDrawer.vue?vue&type=template&id=2d6c09f9&"
import script from "./AppFooterDrawer.vue?vue&type=script&lang=js&"
export * from "./AppFooterDrawer.vue?vue&type=script&lang=js&"
import style0 from "./AppFooterDrawer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports